import { createTheme } from "@mui/material";
import { ptBR } from "@mui/material/locale";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

const Theme = (contrastMode) => {
  return createTheme(
    {
      components: {
        MuiMobileStepper: {
          styleOverrides: {
            dotActive: {
              width: "20px",
              borderRadius: "5px",
              backgroundColor: "#2F2F32",
            },
          },
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              fontFamily: "Unimed-Sans, UnimedSans-Bold, UnimedSans-Black",
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              //borderColor: 'var(--TextField-brandBorderColor)',
            },
            root: {
              [`&:hover:not(.Mui-error) .${outlinedInputClasses.notchedOutline}`]:
                {
                  borderColor: "#7C7C7C",
                  border: "1px solid var(--grey-light-light, #7C7C7C)",
                },
              [`&.Mui-error .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: "#D84141",
              },
              [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: "#7C7C7C",
              },
              [`&.Mui-disabled .${outlinedInputClasses.notchedOutline}`]: {
                background: "var(--grey-light-white, #eeeeee)",
              },
              background: "var(--grey-light-white, #FFF)",
              height: "44px",
              fontFamily: "Unimed-Sans",
            },
            input: {
              [`&.Mui-disabled`]: {
                zIndex: "1",
                "-webkit-text-fill-color": "rgb(0 0 0 / 55%)",
              },
              [`&:focus`]: {
                outline: "none",
                boxShadow: "none",
              },
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "&:hover.MuiButton-outlined": {
                backgroundColor: "#EEE",
                border: "2px solid #164029",
                color: "#164029",
              },
              "& .MuiButton-icon, & .fa": {
                color: "#00995D",
              },
              "& .MuiButton-icon, & .fa, & .contrast-background": {
                color: contrastMode ? "#fff" : "#00995D",
              },
              "&:hover.MuiButton-contained": {
                backgroundColor: "#164029",
              },
              "&.MuiButton-containedError": {
                "&:hover": {
                  backgroundColor: "#8F1131",
                },
              },
            },
            contained: {
              color: "#fff",
              backgroundColor: "#00995D",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "&.MuiButton-containedError": {
                "&:hover": {
                  backgroundColor: "#8F1131",
                },
              },
            },
            outlined: {
              color: contrastMode ? "#fff" : "#00995D",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "&:focus": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
            },
          },
        },
        MuiPaginationItem: {
          styleOverrides: {
            root: {
              backgroundColor: "#00995D",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
              "&.Mui-selected": {
                backgroundColor: "#00995D",
              },
            },
            ellipsis: {
              backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
          },
        },
        MuiRadio: {
          styleOverrides: {
            root: {
              "&.Mui-checked": {
                color: "#00995D",
              },
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            color: "#00995D",
            root: {
              "&.Mui-checked": {
                color: "#00995D",
              },
            },
          },
        },
        MuiTab: {
          styleOverrides: {
            root: {
              borderRadius: "4px",
              textTransform: "none",
              minWidth: "100px",
              "&:focus": {
                border: "2px solid #00995D",
              },
            },
          },
        },
        MuiCircularProgress: {
          styleOverrides: {
            root: {
              color: "#00995D",
            },
          },
        },
        MuiDateCalendar: {
          styleOverrides: {
            root: {
              borderRadius: "10px 10px 0px 0px",
            },
          },
        },
        MuiPickersPopper: {
          styleOverrides: {
            paper: { borderRadius: "10px" },
          },
        },
        MuiPickersDay: {
          styleOverrides: {
            root: {
              "&.Mui-selected": {
                backgroundColor: "#00995D",
                color: "#fff",
              },
              "&:focus": {
                backgroundColor: "#fff",
                outline: "none",
              },
            },
          },
        },
        MuiPickersCalendarHeader: {
          styleOverrides: {
            root: {
              backgroundColor: "#00995D",
              color: "#fff",
              textTransform: "uppercase",
              borderRadius: "10px 10px 0px 0px",
              paddingTop: "15px",
              paddingBottom: "15px",
              margin: "0",
              maxHeight: "none",
            },
            labelContainer: {
              fontFamily: "Unimed-Sans",
              fontWeight: "700",
            },
            switchViewButton: {
              color: "#fff",
            },
          },
          MuiPickersArrowSwitcher: {
            styleOverrides: {
              root: {
                color: "#fff",
                "& .MuiIconButton-root": {
                  color: "#fff",
                },
              },
            },
          },
        },
      },

      variables: {
        "--grey-light-light": "#EEEEEE",
        "--grey-light-white": "#FFFFFF",
        "--grey-light-medium": "#BDBDBD",
        "--grey-light-dark": "#343A40",
      },
      palette: {
        primary: {
          main: "rgba(0, 0, 0, 0.08)",
          light: "#90CAA6",
          dark: "#164029",
        },
        success: {
          main: "#00995D",
        },
      },
    },
    ptBR
  );
};

export default Theme;
